import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_CUSTOMER_INVOICES,
    GET_CUSTOMER_INVOICE_DETAIL,
    ADD_NEW_CUSTOMER_INVOICE,
    UPDATE_CUSTOMER_INVOICE,
    DELETE_CUSTOMER_INVOICE,
    ADD_NEW_PAYMENT,
} from "./actionTypes"

import {
    getCustomerInvoicesSuccess,
    getCustomerInvoicesFail,
    getCustomerInvoiceDetailSuccess,
    getCustomerInvoiceDetailFail,
    addNewCustomerInvoiceSuccess,
    addNewCustomerInvoiceFail,
    updateCustomerInvoiceSuccess,
    updateCustomerInvoiceFail,
    deleteCustomerInvoiceSuccess,
    deleteCustomerInvoiceFail,
    addNewPaymentSuccess,
    addNewPaymentFail,
} from "./actions"

import {
    getInvoices,
    getInvoiceDetail,
    addNewInvoice,
    updateInvoice,
    deleteInvoice,
    addNewPayment,
} from "../../helpers/fakebackend_helper"

function* fetchCustomerInvoices({ payload: params }) {
    try {
        const response = yield call(getInvoices, params)
        yield put(getCustomerInvoicesSuccess(response))
    } catch (error) {
        yield put(getCustomerInvoicesFail(error))
    }
}

function* fetchCustomerInvoiceDetail({ payload: id }) {
    try {
        const response = yield call(getInvoiceDetail, id)
        yield put(getCustomerInvoiceDetailSuccess(response))
    } catch (error) {
        yield put(getCustomerInvoiceDetailFail(error))
    }
}

function* onAddNewCustomerInvoice({ payload: invoice }) {
    try {
        const response = yield call(addNewInvoice, invoice)
        yield put(addNewCustomerInvoiceSuccess(response.invoice))
    } catch (error) {
        yield put(addNewCustomerInvoiceFail(error))
    }
}

function* onUpdateCustomerInvoice({ payload: invoice }) {
    try {
        const response = yield call(updateInvoice, invoice)
        yield put(updateCustomerInvoiceSuccess(response.invoice))
    } catch (error) {
        yield put(updateCustomerInvoiceFail(error))
    }
}

function* onDeleteCustomerInvoice({ payload: id }) {
    try {
        yield call(deleteInvoice, id)
        yield put(deleteCustomerInvoiceSuccess(id))
    } catch (error) {
        yield put(deleteCustomerInvoiceFail(error))
    }
}

function* onAddNewPayment({ payload: payment }) {
    try {
        const response = yield call(addNewPayment, payment)
        yield put(addNewPaymentSuccess(response.payment))
    } catch (error) {
        yield put(addNewPaymentFail(error))
    }
}

function* invoicesSaga() {
    yield takeEvery(GET_CUSTOMER_INVOICES, fetchCustomerInvoices)
    yield takeEvery(GET_CUSTOMER_INVOICE_DETAIL, fetchCustomerInvoiceDetail)
    yield takeEvery(ADD_NEW_CUSTOMER_INVOICE, onAddNewCustomerInvoice)
    yield takeEvery(UPDATE_CUSTOMER_INVOICE, onUpdateCustomerInvoice)
    yield takeEvery(DELETE_CUSTOMER_INVOICE, onDeleteCustomerInvoice)
    yield takeEvery(ADD_NEW_PAYMENT, onAddNewPayment)
}

export default invoicesSaga
